import { Option, Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isInteger, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isAttachmentFolder, isTimestamp, } from "@cartographerio/types";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "location", isNullable(isPoint)) &&
        hasOptionalKey(data, "collectedOnBehalfOf", isNullable(isString)) &&
        hasOptionalKey(data, "numberOfPlants", isNullable(isInteger)) &&
        hasOptionalKey(data, "percentagePlantCover", isNullable(isInteger)) &&
        hasOptionalKey(data, "plantSpecies", isNullable(isString)) &&
        hasOptionalKey(data, "invasivePlantSpecies", isNullable(isString)) &&
        hasOptionalKey(data, "wildlife", isNullable(isString)) &&
        hasKey(data, "photographs", isAttachmentFolder) &&
        hasOptionalKey(data, "comments", isNullable(isString)));
}
const g = Result.guard(isPartialData, "PartialData");
export function dataDescription(data) {
    return g(data).map((data) => Option.wrap(data.location)
        .map(safePointToNgr)
        .getOrElse(() => "Unknown NGR"));
}
export function dataTimestamp(data) {
    return g(data).map((data) => data.recorded ?? null);
}
export function dataGeometry(data) {
    return g(data).map((data) => data?.location ?? null);
}
export function copyData(data) {
    return g(data);
}
//# sourceMappingURL=parts.js.map